"use client";

import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@/components/atoms/Text/Text";
import { cn } from "@/lib/utils";

const labelVariants = cva(
  "tw-body-2-m tw-inline-block peer-disabled:tw-pointer-events-none peer-disabled:tw-text-gray-500 tw-mb-0",
);

export type LabelProps = React.ComponentPropsWithoutRef<
  typeof LabelPrimitive.Root
> &
  VariantProps<typeof labelVariants> & {
    required?: boolean;
  };

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, required, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ className }))}
    aria-required={required}
    {...props}
  >
    {children}
    {required && (
      <>
        {" "}
        <Text className="tw-text-gray-600" typeface="body-2">
          (<FormattedMessage defaultMessage="required" />)
        </Text>
      </>
    )}
  </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;
